export const expNameField = {
  type: 'field',
  name: 'Experiment Name',
  propLocation: 'Payload.experimentName'
};

export const showNoShowField = {
  type: 'field',
  name: 'Content/No Content Experiment',
  propLocation: 'Payload.IsNoShowExperiment',
  defaultValue: false
};

export const showServerSideField = {
  type: 'field',
  name: 'Run as Server-side Experiment',
  propLocation: 'Payload.IsServerSideExperiment',
  defaultValue: false
};

export const variantsField = {
  type: 'field',
  name: 'Experiment Components',
  canvasWidget: 'AttachChildInput',
  propLocation: 'Payload.variants',
  defaultValue: [],
  allowedChildComponents: [
    'Accordion',
    'Accordion Item Content',
    'Brand Banner',
    'Content Header',
    'Content Header Carousel',
    'Copy Only',
    'Enticement Flag',
    'Experiment',
    'Explore More Tile',
    'Explore More Tray',
    'Header Filter Below',
    'Header Filter Below Quiz',
    'iFrame',
    'Image Only',
    'Looks Rec Tray',
    'Loyalty Tile',
    'Olivia Kim Secondary Nav',
    'PDP Module',
    'Personalized HP Tile',
    'Promo Tile',
    'Ranked Results',
    'Recommendations 3.0',
    'Responsive Carousel',
    'Responsive Staggered Group',
    'Selling Essentials Enticement',
    'Selling Essentials Enticement Placements Container',
    'Tab',
    'Tab Item Content',
    'Tile',
    'Video',
    'Whitespace'
  ],
  defaultParameter: 'Default'
};

export default {
  type: 'contract',
  name: 'Experiment',
  children: [expNameField, showNoShowField, showServerSideField, variantsField]
};
